import { User } from 'src/app/entities/user/user';
import { Mapper } from './mapper';
import { UserDto } from '../dtos/user.dto';

export class UserMapper extends Mapper<User, UserDto> {
  mapToEntity(dto: UserDto): User {
    return new User(
      dto.uuid,
      dto.name,
      dto.status,
      dto.mail,
      dto.roles,
      dto.permissions
    );
  }


}
